import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  AdminDashboardState,
  FetchDashboardSessionsFailedPayload,
  FetchDashboardSessionsPayload,
} from './types';
import { ChatSession } from '../../../layouts/MainLayout/slice/types';
import { SESSION_TYPES } from '../../chat/slice/constants';
import { ITimeLineItem } from '../../chat/slice/types';

export const initialState: AdminDashboardState = {
  chatSessions: [],
  callSessions: [],
  latestTimeLineItems:[],
  isLoading: false,
  error: null,
};

export const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {
    fetchDashboardSessionsRequested(state, action: PayloadAction<FetchDashboardSessionsPayload>) {
      state.isLoading = true;
      state.error = null;
      state.chatSessions = [];
      state.callSessions = [];
      state.latestTimeLineItems = [];
    },


    fetchDashboardSessionsSucceeded(state, action: PayloadAction<{chatSessions: ChatSession[], latestTimeLineItems: ITimeLineItem[]}>) {
      state.chatSessions = action.payload.chatSessions.filter((session) => session.sessionType === SESSION_TYPES.CHAT);
      state.callSessions = action.payload.chatSessions.filter((session) => session.sessionType === SESSION_TYPES.CALL);
      state.latestTimeLineItems = action.payload.latestTimeLineItems;
      state.isLoading = false;
      state.error = null;
     
    },

    fetchDashboardSessionsFailed(state, action: PayloadAction<FetchDashboardSessionsFailedPayload>) {
      const {  message } = action.payload;
      state.isLoading = false;
      state.error = message;
    },

    clearDashboardRecord(state) {
      state.isLoading = false;
      state.error = null;
      state.chatSessions = [];
      state.callSessions = [];
    },
  },
});

export const { actions: adminDashboardActions } = adminDashboardSlice;

export const useAdminDashboardSlice = () => {
  return { actions: adminDashboardSlice.actions };
};

